import React, { useEffect, useState, useMemo } from 'react';
import { Dropdown } from '@etiquette-ui/inputs-dropdowns';
import IconLink from 'components/IconLink';

import CardContainer from 'containers/CardContainer';
import ResponsiveCard from 'containers/ResponsiveCard';
import ListActionsContainer from 'pages/MenuItems/containers/ListActionsContainer';
import ListLayout from 'pages/MenuItems/containers/ListLayout';
import ResponsiveSpacer from 'pages/MenuItems/components/ResponsiveSpacer';
import ResponsiveTitleContainer from 'pages/MenuItems/containers/ResponsiveTitleContainer';
import FormTitle from 'pages/MenuItems/components/FormTitle';
import useTranslatedFilterSelect from 'hooks/useTranslatedFilterSelect';

import Table from 'components/Table';
import useCategories from 'state/categories';
import structure from './structure';
import useI18n from 'i18n/useI18n';

import {
  getProcessedCategories
} from 'pages/MenuItems/utils/transformers';

import { filterByParentCategory } from 'pages/MenuItems/utils/filters';
import DragHandle from 'components/Table/DragHandle';
const List = ({ location }) => {
  const { translate } = useI18n();

  const [data, setData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, dispatcher] = useCategories();

  useEffect(() => {
    dispatcher.fetchStart();
  }, [])

  useEffect(() => {
    if(!selectedCategory) return;
    const filtered = filterByParentCategory(categories.subcategories, [selectedCategory]);
    setData(filtered);
  }, [categories.subcategories, selectedCategory])

  const processedCategories = useMemo(() => {
    return getProcessedCategories(categories);
  }, [categories]);

  const [options, selectedOption] = useTranslatedFilterSelect(
    processedCategories,
    selectedCategory,
    setSelectedCategory
  );

  const onSort = ({ newIndex, oldIndex, commitMove }) => {
    const newData = [...data];
    const element = newData[oldIndex];
    let isSetAsFirst = false;

    if(newIndex === 0 && oldIndex > 0){
        isSetAsFirst = true;
    } else if(newIndex-1 < 0) return;
    
    const previousElement = newData[isSetAsFirst ? newIndex : newIndex-1];
    if(!isSetAsFirst && !previousElement.position) return;

    commitMove();

    dispatcher.position({
      id: element.id,
      position: newIndex + 1,
    });
  };

  return (
    <ListLayout>
      <ListActionsContainer>
        <IconLink to={'/menu/subcategories'}>{translate('Back to Menu Subcategories')}</IconLink>
        
        <ResponsiveTitleContainer>
          <FormTitle>{translate('Arrange')}</FormTitle>
        </ResponsiveTitleContainer>
        
        <div>
          <Dropdown
            labelProps={{ label: translate('Category') }}
            containerProps ={{
              styles: {
                width: '300px'
              }
            }}
            selectProps={{
              onChange: setSelectedCategory,
              options,
              value: selectedOption
            }}
          />
        </div>
      </ListActionsContainer>
      <ResponsiveSpacer />
      <CardContainer>
        <ResponsiveCard>
          <Table
            items={data}
            structure={structure}
            config={{ translate }}
            onSortEnd={onSort}
            dragHandle={<DragHandle />}
            dragable={true}
          />
        </ResponsiveCard>
      </CardContainer>
    </ListLayout>
  );
};


export default List;
